export default __webpack_public_path__ + "static/media/fester-impermeabilizante.43524cc0.jpg";